import { t } from 'javascripts/utils/withTranslation';

function calculateReadingTime(text) {
  const wordsPerMinute = 250;
  const numberOfWords = text.split(/\s/g).length;
  return Math.ceil(numberOfWords / wordsPerMinute);
}

document.querySelectorAll('.js-reading-time').forEach(($el) => {
  const $article = document.querySelector('.article');
  const $e = $el;
  if (!$article) {
    console.error('Article element not found');
    $e.textContent = t('Lesezeit unbekannt');
    return;
  }

  const blacklistClasses = [
    'teaser__hashtags',
    'figure',
    'teaser',
    'teaser-slider',
  ];
  const $text = $article.querySelectorAll(
    '.article__section > .text, .article__section .accordion .text'
  );

  const text = Array.from($text).reduce((acc, $node) => {
    const $clone = $node.cloneNode(true);

    blacklistClasses.forEach((blackListClass) => {
      $clone
        .querySelectorAll(`.${blackListClass}`)
        .forEach((blacklistedNode) => {
          blacklistedNode.remove();
        });
    });

    return acc + $clone.textContent;
  }, '');

  const readingTime = calculateReadingTime(text);

  $e.innerHTML = `${t('Lesezeit')}: ${readingTime}&nbsp;${
    readingTime > 1 ? t('Minuten') : t('Minute')
  }`;
});

export default calculateReadingTime;
